import React from "react";

const RectangleDitrict = ({ width, height, color }) => {
  return (
    <svg
      width="11"
      height="5"
      viewBox="0 0 11 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="11" height="5" rx="2.5" fill="#857BFF" />
    </svg>
  );
};

export default RectangleDitrict;
